import { withLazyInitialization } from "@buildwithflux/shared";
import { ActionRecordAdminConverter, ActionRecordClientConverter } from "./ActionRecordConverter";
import { DocumentAdminConverter, DocumentClientConverter } from "./DocumentConverter";
import { ElementAdminConverter, ElementClientConverter } from "./ElementConverter";
import { HandleMappingAdminConverter, HandleMappingClientConverter } from "./HandleMappingConverter";
import { PartVersionAdminConverter, PartVersionClientConverter } from "./PartVersionConverter";
import { PropertyAdminConverter, PropertyClientConverter } from "./PropertyConverter";
import { UnsafeAdminConverter, UnsafeClientConverter, UnsafeWithCustomStrategyAdminConverter, UnsafeWithSubcollectionOverwriteAdminConverter, UnsafeWithSubcollectionOverwriteClientConverter, } from "./UnsafeConverter";
import { UnsafeToPlainMigrationAdminConverter, UnsafeToPlainMigrationClientConverter, } from "./UnsafeToPlainMigrationConverter";
export function createAdminConverters(metadataGenerator) {
    return withLazyInitialization({
        documentConverterFactory: () => (strategy) => {
            return new DocumentAdminConverter(metadataGenerator, strategy);
        },
        elementConverter: () => new ElementAdminConverter(metadataGenerator),
        propertyConverter: () => new PropertyAdminConverter(metadataGenerator),
        actionRecordConverter: () => new ActionRecordAdminConverter(),
        handleMappingConverter: () => new HandleMappingAdminConverter(),
        partVersionConverter: () => new PartVersionAdminConverter(),
        unsafeConverterFactory: () => () => new UnsafeAdminConverter(metadataGenerator),
        unsafeWithSubcollectionOverwriteConverterFactory: () => () => new UnsafeWithSubcollectionOverwriteAdminConverter(metadataGenerator),
        unsafeWithCustomStrategyConverterFactory: () => (strategy) => new UnsafeWithCustomStrategyAdminConverter(metadataGenerator, strategy),
        unsafeToPlainMigrationConverterFactory: () => () => new UnsafeToPlainMigrationAdminConverter(),
    }, {});
}
export function createClientConverters(metadataGenerator) {
    return withLazyInitialization({
        documentConverterFactory: () => (strategy) => {
            return new DocumentClientConverter(metadataGenerator, strategy);
        },
        elementConverter: () => new ElementClientConverter(metadataGenerator),
        propertyConverter: () => new PropertyClientConverter(metadataGenerator),
        actionRecordConverter: () => new ActionRecordClientConverter(),
        handleMappingConverter: () => new HandleMappingClientConverter(),
        partVersionConverter: () => new PartVersionClientConverter(),
        unsafeConverterFactory: () => () => new UnsafeClientConverter(metadataGenerator),
        unsafeWithSubcollectionOverwriteConverterFactory: () => () => new UnsafeWithSubcollectionOverwriteClientConverter(metadataGenerator),
        unsafeToPlainMigrationConverterFactory: () => () => new UnsafeToPlainMigrationClientConverter(),
    }, {});
}
//# sourceMappingURL=factory.js.map